import { Transport, TransportRequest, TransportResponse } from "./Transport"

export class BeaconTransport implements Transport {
  static create(): BeaconTransport {
    return new BeaconTransport()
  }

  send(request: TransportRequest): Promise<TransportResponse> {
    return new Promise((resolve, reject) => {
      let beaconSupport = false

      if (typeof window !== "undefined") {
        beaconSupport = window && window.navigator && !!window.navigator.sendBeacon && true
      }
      if (!beaconSupport) {
        throw new Error("BeaconTransport not supported.")
      }

      let body = this.createBody(request)
      const success = window.navigator.sendBeacon(request.url.toString(), body)
      if (!success) {
        throw Error("Failed to sendBeacon")
      }

      resolve(TransportResponse.ok())
    })
  }

  private createBody(request: TransportRequest): URLSearchParams {
    const params = new URLSearchParams()
    if (request.body) {
      params.append("data", request.body)
    }
    return params
  }
}
